import { render, staticRenderFns } from "./title.vue?vue&type=template&id=67f6221a&scoped=true"
import script from "./title.vue?vue&type=script&lang=ts"
export * from "./title.vue?vue&type=script&lang=ts"
import style0 from "./title.vue?vue&type=style&index=0&id=67f6221a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f6221a",
  null
  
)

export default component.exports